<template>
  <div class="more-lift-item risk-item">
    <template v-if="isRiskPage">
      <div class="more-title">
        <p :text="riskData.domainName">{{ riskData.domainName }}</p>
      </div>
      <div class="more-content">
        <div class="lift-risk-index" v-if="riskData.riskEstimate">
          <div class="circle-box" ref="circleBox"></div>
          <div class="circle-text">
            <div>
              <span>{{ $l("风险指数") }} </span>
              <em>{{ riskData.riskScore }}</em>
            </div>
          </div>
        </div>
        <div class="lift-info risk-info">
          <div>
            <label>{{ $l("出厂编号：") }} </label>
            <span>{{ riskData.jobNum }}</span>
          </div>
          <div>
            <label>{{ $l("注册代码：") }} </label>
            <span>{{ riskData.registerCode }}</span>
          </div>
          <div>
            <label>{{ $l("风险评估：") }} </label>
            <span
              :style="{ color: riskColors[riskData.riskEstimate][1] }"
              v-if="riskData.riskEstimate"
              >{{ riskData.riskEstimate }}</span
            >
          </div>
          <div>
            <label>{{ $l("预警次数：") }} </label>
            <span>{{ riskData.faultCount }}</span>
          </div>
          <div>
            <label>{{ $l("预警时间：") }} </label>
            <span>{{ riskData.alarmDate }}</span>
          </div>
          <div>
            <label>{{ $l("预警内容：") }} </label>
            <span
              :style="{
                color: riskData.riskEstimate
                  ? riskColors[riskData.riskEstimate][1]
                  : '#f7faff',
              }"
              >{{ riskData.description }}</span
            >
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="more-title">
        <p
          :text="
            (infoData.domainName || '') +
              (infoData.buildingName || '') +
              (infoData.elevatorNum || '') || ''
          "
        >
          {{
            (infoData.domainName || "") +
              (infoData.buildingName || "") +
              (infoData.elevatorNum || "") || ""
          }}
        </p>
      </div>
      <div class="more-content">
        <div class="lift-info">
          <div>
            <label>{{ $l("出厂编号：") }} </label>
            <span @click.stop="clickSearch">{{ infoData.jobNum }}</span>
            <i v-show="isSearch" @click.stop="clickSearch"></i>
          </div>
          <div>
            <label>{{ $l("运行模式：") }} </label>
            <span>{{ statusValue("运行ACD") }}</span>
          </div>
          <div>
            <label>{{ $l("运行次数：") }} </label>
            <span>{{ statusValue("运行次数") }}次</span>
          </div>
          <div>
            <label>{{ $l("运行速度：") }} </label>
            <span>{{
              statusValue("速度（米/分）") | formatDuring("米/分")
            }}</span>
          </div>
          <div>
            <label>{{ $l("运行时长：") }} </label>
            <span>{{
              statusValue("运行时间（分）") | formatDuring("分")
            }}</span>
          </div>
          <div>
            <label>{{ $l("梯龄：") }} </label>
            <span>{{ infoData.elevatorAge }}年</span>
          </div>
          <div>
            <label>{{ $l("城市：") }} </label>
            <span>{{ infoData.city }}</span>
          </div>
          <div>
            <label>{{ $l("品牌：") }} </label>
            <span>{{ infoData.brand }}</span>
          </div>
          <div>
            <label>{{ $l("注册代码：") }} </label>
            <span>{{ infoData.registerCode }}</span>
          </div>
        </div>
        <div
          class="lift-run-state"
          ref="liftRunState"
          v-if="infoData.elevatorType == '直梯'"
        >
          <div class="more-floor-box">
            <div
              class="direction"
              :class="
                infoData.RunDirection == 1
                  ? 'floor-up'
                  : infoData.RunDirection == 2
                  ? 'floor-below'
                  : ''
              "
            >
              <span>{{ infoData | realFloor }}</span>
            </div>
            <div class="weight">
              <span>{{ $l("载重比") }} </span>
              <span>{{ infoData.Carry }}%</span>
            </div>
          </div>
        </div>
        <div class="more-escalator-box" ref="moreEscalatorBox" v-else>
          <div
            class="btn-direction"
            :class="
              infoData.RunDirection == 1
                ? 'direction-up'
                : infoData.RunDirection == 2
                ? 'direction-below'
                : ''
            "
          ></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from "echarts";
import CanvasKeyFrames from "../plugins/canvas-keyframes";
export default {
  name: "screenMonitorItem",
  props: {
    isSearch: Boolean,
    infoData: {
      type: Object,
      default: () => {},
    },
    runData: {
      type: Object,
      default: () => {
        return { faultStatus: [], runStatus: [], otherStatus: [] };
      },
    },
    isRiskPage: false,
    riskData: {
      type: Object,
      default: () => {},
    },
    screenWatch: Number,
  },
  data() {
    return {
      riskChart: null,
      keyFrames: null,
      riskColors: {
        低: ["#C0EDA0", "#8AE4EF"],
        中: ["#DCCD8A", "#FFCE7F"],
        高: ["#FFAA88", "#FB5C5D"],
      },
    };
  },
  filters: {
    formatDuring(millisecond, unit) {
      millisecond = millisecond || 0;
      return isNaN(millisecond * 1) ? millisecond : millisecond + unit;
      // return Math.floor(millisecond / 60) + "小时" + (millisecond % 60) + "分";
    },
    realFloor(elevator) {
      const floor = elevator.Floor;
      if (!floor || floor == "0") {
        return " ";
      }
      const realFloorList = elevator.realFloorList;
      if (realFloorList != null && realFloorList.length > 0) {
        for (let i = 0; i < realFloorList.length; i++) {
          const item = realFloorList[i];
          if (item.floorcode == floor) {
            return item.description + "F";
          }
        }
      }
      return floor + "F";
    },
  },
  computed: {
    statusValue() {
      return (name) => {
        let arr = this.runData.runStatus.flat(Infinity);
        arr = arr.concat(this.runData.otherStatus);
        let index = arr.findIndex((v) => v.name == name);
        if (index == -1) return "";
        return arr[index].value;
      };
    },
  },
  watch: {
    screenWatch() {
      if (this.isRiskPage) {
        this.riskChart && this.getRiskIndex(true);
      } else {
        const { elevatorType, RunDirection, DoorState } = this.infoData;
        const isEscalator = elevatorType != "直梯";
        let state = isEscalator
          ? RunDirection == 1
            ? "open"
            : RunDirection == 2
            ? "close"
            : ""
          : DoorState;
        this.playDoorAnimation(state, true);
      }
    },
    "infoData.DoorState"() {
      if (this.infoData.elevatorType != "直梯") return false;
      const { DoorState } = this.infoData;
      if (DoorState == "open") {
        this.playDoorAnimation("open");
      } else if (DoorState == "close") {
        this.playDoorAnimation("close");
      }
    },
    "infoData.RunDirection"() {
      if (this.infoData.elevatorType == "直梯") return false;
      const { RunDirection } = this.infoData;
      if (RunDirection == 1) {
        this.playDoorAnimation("open");
      } else if (RunDirection == 2) {
        this.playDoorAnimation("close");
      }
    },
    "infoData.elevatorType"() {
      if (this.isRiskPage) return false;
      this.playDoorAnimation(null);
    },
  },
  created() {},
  mounted() {
    this.getRiskIndex();
    if (this.isRiskPage) return false;
    this.playDoorAnimation(null);
  },
  methods: {
    playDoorAnimation(type, resize) {
      const isEscalator = this.infoData.elevatorType != "直梯";
      if (!!this.keyFrames && !type) {
        this.keyFrames.destroy();
      }
      const f = this.keyFrames;
      this.keyFrames = null;
      let count = 0;
      let num = 0;
      if (type == "close") {
        num = 10;
      }
      if (this.isRiskPage) return console.log("riskPage-return");
      const FrameImgArr = [];
      const initKeyFrames = (imgArr) => {
        // console.log(imgArr);
        let doc = this.$refs[isEscalator ? "moreEscalatorBox" : "liftRunState"];
        this.keyFrames = new CanvasKeyFrames(doc, "array", imgArr, {
          fps: 10,
          loop: isEscalator ? "infinite" : 1,
          right: "10%",
        });
        if (f) f.destroy(); //防止闪烁
        if (resize && !isEscalator) this.keyFrames.goto(imgArr.length - 1);
        else this.keyFrames.play();
      };
      const createImg = (i) => {
        let img = new Image();
        img.onload = function () {
          img.onload = null;
          count++;
          FrameImgArr[i] = img;
          if (isEscalator && count == 7) {
            initKeyFrames(FrameImgArr);
          }
          if (count == 10) {
            initKeyFrames(FrameImgArr);
          }
          if (!type) {
            initKeyFrames(FrameImgArr);
          }
        };
        img.onerror = function (err) {
          console.log(err);
        };
        if (isEscalator) {
          img.src = require(`../assets/img/largeScreen/animation/扶梯${
            type == "close" ? i + 1 : 6 - i + 1
          }.png`);
        } else {
          img.src = require(`../assets/img/largeScreen/animation/电梯动画${
            i + 1 + num
          }.png`);
        }
      };
      if (!type) {
        num = 19;
        createImg(0);
        return;
      }
      let len = 10;
      if (isEscalator) len = 7;
      for (let i = 0; i < len; i++) {
        createImg(i);
      }
    },
    clickSearch() {
      if (!this.isSearch) return false;
      this.$emit("search");
    },
    transformFontSize(fontsize) {
      const width = window.screenWidth || 1920;
      const ratio = width / 1920;
      return fontsize * ratio;
    },
    getRiskIndex(resize) {
      if (!this.isRiskPage || !this.riskData.riskEstimate) return false;
      let chartDom = this.$refs.circleBox;
      this.riskChart = echarts.init(chartDom);
      const { riskEstimate } = this.riskData;
      const lineData = {
        value: this.riskData.riskScore || 0,
        // value: 82,
        name: "风险指数",
      };
      let option = {
        backgroundColor: "transparent",
        tooltip: {
          show: false,
          trigger: "item",
          className: "tooltip",
          order: "seriesDesc",
          // 设置背景颜色
          backgroundColor: "transparent",
          borderColor: "#1b366a", // 边框颜色
          textStyle: { color: "#fff" }, // 字体颜色
          formatter: "{b} : {c} %",
        },
        polar: {
          radius: ["100%", "60%"],
          center: ["50%", "50%"],
        },
        angleAxis: {
          max: 100, //最大刻度
          show: false,
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          // 外圈
          {
            name: lineData.name,
            data: [lineData],
            radius: "100%",
            type: "bar",
            roundCap: true,
            barWidth: this.transformFontSize(10),
            showBackground: true,
            backgroundStyle: {
              color: "transparent",
            },
            coordinateSystem: "polar",
            // 样式-颜色
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: this.riskColors[riskEstimate][1],
                  },
                  {
                    offset: 1,
                    color: this.riskColors[riskEstimate][0],
                  },
                ]),
              },
            },
          },
          // 内圈
          {
            data: [{ show: false, value: "100" }], //作用不清楚
            name: "灰色内圈", //刻度背景
            type: "gauge",
            radius: "82%",
            startAngle: "0",
            endAngle: "-359.99",
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[1, "#2A48A4"]],
                width: this.transformFontSize(3),
                opacity: 1, //刻度背景宽度
              },
            },
            splitLine: {
              show: false,
            },

            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: 0,
            },
          },
        ],
      };
      option && this.riskChart.setOption(option);
      resize && this.riskChart.resize();
    },
  },
};
</script>

<style scoped lang="scss">
.more-lift-item {
  position: relative;
  width: 32%;
  height: 45%;
  // border: 1px solid #089cd773;
  background: url(../assets/img/largeScreen/riskItem_bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  margin-right: 0.4%;
  &:nth-child(3n) {
    margin-right: 0;
  }
  // &::after {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   bottom: 0;
  //   right: 0;
  //   background: url(../assets/img/largeScreen/g.png) no-repeat;
  //   background-size: 100% 100%;
  //   box-shadow: 0px 0px 0px 1px #089cd773, inset 0px 0px 20px 0px #089cd773;
  // }
}
.risk-item {
  margin-right: 2%;
}
.more-title {
  height: vh(60);
  // background: url(../assets/img/largeScreen/boxTitleBgc.png) no-repeat;
  // background-size: cover;
  font-size: 1.125rem;
  // font-family: JiangChengXieHei;
  font-weight: 700;
  color: #ffffff;
  padding-left: vw(32);
  display: flex;
  align-items: center;
  &::before {
    content: "";
    width: vw(30);
    height: vw(30);
    background: url(../assets/img/largeScreen/location.png) no-repeat;
    background-size: 100% 100%;
    margin-right: vw(4);
    position: relative;
    z-index: 3;
  }
  p {
    flex: 1;
    position: relative;
    z-index: 3;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: transparent;
    // text-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.45);
    &::after {
      content: attr(text);
      position: absolute;
      left: 0;
      z-index: 9;
      color: #ffffff;
      text-align: center;
      background-image: linear-gradient(to top, #aec5fe, #ffffff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: none;
    }
  }
}
.more-content {
  flex: 1;
  min-height: 10px;
  // background-color: rgba(4, 12, 22, 0.7);
  padding: vh(0) vw(15) vh(20) vw(10);
  display: flex;
  justify-content: space-between;
}
.lift-info {
  flex: 1;
  font-size: 0.875rem;
  // font-family: AlibabaPuHuiTi;
  position: relative;
  z-index: 3;
  margin-left: vw(40);
  div {
    padding: vh(5) 0;
    display: flex;
    align-items: center;
    + div {
      border-top: 1px dashed rgba(#728fe9, 0.4);
    }
  }
  label {
    position: relative;
    min-width: vw(80);
    color: var(--bs-color-text-regular);
    &:before {
      content: "";
      position: absolute;
      left: -1em;
      top: 50%;
      transform: translateY(-50%);
      width: vw(4);
      height: vh(4);
      border-radius: 1px;
      background: rgba(#3863e9, 0.5);
    }
  }
  span {
    color: var(--bs-color-text-primary);
  }
  i {
    display: inline-block;
    width: vh(25);
    height: vh(25);
    background: url(../assets/img/largeScreen/search.png) no-repeat;
    background-size: 100% 100%;
    margin-left: vw(15);
    margin-bottom: vh(-3);
    cursor: pointer;
  }
}
.lift-run-state {
  width: vw(300);
  position: relative;
  z-index: 3;
  // background: url(../assets/img/largeScreen/verticalLift.png) no-repeat;
  // background-position: 80% center;
  // background-size: contain;
}
@keyframes floor {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
.more-floor-box {
  z-index: 5;
  position: absolute;
  left: 6%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  .direction {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: vh(20) 0;
    &::before,
    &::after {
      content: "";
      display: block;
      width: vw(68);
      height: vw(68);
      background: url(../assets/img/largeScreen/liftUpBtn.png) no-repeat;
      background-size: contain;
      opacity: 0.3;
    }
    &::after {
      background-image: url(../assets/img/largeScreen/liftBelowBtn.png);
    }
    span {
      height: vh(50);
    }
  }
  .floor-up::before {
    animation: floor 1.5s linear infinite normal;
  }
  .floor-below::after {
    animation: floor 1.5s linear infinite normal;
  }
  span {
    font-size: 1.9375rem;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #c5dfef;
    background: linear-gradient(0deg, #acddff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .weight {
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 0.875rem;
    }
  }
}
.more-escalator-box {
  width: vw(300);
  position: relative;
  z-index: 3;
  // background: url(../assets/img/largeScreen/escalator.png) no-repeat;
  // background-position: 80% center;
  // background-size: contain;
}
.btn-direction {
  position: absolute;
  z-index: 5;
  position: absolute;
  right: 6%;
  top: 15%;
  width: vw(68);
  height: vw(68);
}
.direction-below {
  background: url(../assets/img/largeScreen/liftBelowBtn.png) no-repeat;
  background-size: contain;
  animation: floor 1.5s linear infinite normal;
}
.direction-up {
  background: url(../assets/img/largeScreen/liftUpBtn.png) no-repeat;
  background-size: contain;
  animation: floor 1.5s linear infinite normal;
}
.risk-info {
  flex: auto;
  margin-right: vw(16);
  margin-left: 0;
}
.lift-risk-index {
  flex: 1;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 vw(42);
}
.circle-box {
  width: vw(166);
  height: vw(166);
  background: url(../assets/img/largeScreen/largeScreenProgressBgc.png)
    no-repeat;
  background-size: 100%;
}
.circle-text {
  width: vw(166);
  height: vw(166);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #a1c7fc;
    span {
      font-size: 1rem;
      // font-family: AlibabaPuHuiTi;
      font-weight: 500;
      margin-bottom: 0.4em;
    }
    em {
      font-style: normal;
      font-family: DINCond-Bold;
      font-weight: 400;
      background: linear-gradient(to bottom, #9cd0f7 0%, #7f9cff 100%);
      // background: linear-gradient(to bottom, #fcb79f 0%, #9cd0f7 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 3.5rem;
      line-height: 1;
    }
  }
}
</style>
